import React, { PropsWithChildren } from 'react'
import { toast } from '@workwhile/ui'
import { createContext } from 'lib/createContext'
import { useDeleteRateMutation } from 'queries/wage/useDeleteRateMutation'
import { useRuleDetailWorkflowsContextValue } from '../../../context/RuleDetailWorkflowsProvider'

type DeleteRateConfirmFlowContextState = {
  state: {
    isPending: boolean
  }
  actions: {
    confirm: () => void
  }
}

const [Context, useDeleteRateConfirmFlowContextValue] =
  createContext<DeleteRateConfirmFlowContextState>({
    name: 'DeleteRateConfirmFlowContext',
  })

export const DeleteRateConfirmFlowProvider = ({
  children,
  ruleId,
}: PropsWithChildren<{ ruleId: number }>) => {
  const { deleteRateConfirmFlow } = useRuleDetailWorkflowsContextValue()
  const { mutate: deleteRate, isPending } = useDeleteRateMutation(ruleId)

  const value: DeleteRateConfirmFlowContextState = {
    state: { isPending },
    actions: {
      confirm: () => {
        const { selectedRate, close } = deleteRateConfirmFlow
        if (!selectedRate) return
        deleteRate(
          { ruleId, rateId: selectedRate.id },
          {
            onSuccess: () => {
              toast.success('Rate deleted', { position: 'top-center' })
              close()
            },
          }
        )
      },
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useDeleteRateConfirmFlowContextValue }
